// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../../../hooks/useIntl';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: () => void,
};

function MigrationNotStartedModal({ open, onClose }: Props) {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onClose={onClose}
      status="warning"
      icon={<AlertIcon />}
      title={intl.formatMessage(messages.notStartedTitle)}
      actions={
        <Button variant="primary" onClick={onClose}>
          <FormattedMessage {...messages.gotIt} />
        </Button>
      }
    >
      <Stack spacing={2}>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.notStartedSaved} />
        </Typography>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.notStartedUnchanged} />
        </Typography>
      </Stack>
    </Modal>
  );
}

export default MigrationNotStartedModal;
